import { useEffect } from 'react'

import { useSetRecoilState } from 'recoil'

import { brandLogoState } from 'src/atoms/ui.atom'

export function useSetBrandLogo(brandLogo?: string) {
  const setBrandLogoState = useSetRecoilState(brandLogoState)
  useEffect(() => {
    setBrandLogoState(brandLogo)
  }, [brandLogo, setBrandLogoState])
}
